import { useContext, Dispatch } from "react";

import { StateContext } from "config/state";

export const initialState = {
  availableCoursesFilters: {
    pagination: { rowsPerPage: 10 },
    orderBy: ["createdAt,DESC"]
  }
};

type State = typeof initialState;

export enum actionTypes {
  SET_AVAILABLE_COURSES_FILTERS = "setAvailableCoursesFilters",
  RESET_AVAILABLE_COURSES_FILTERS = "resetAvailableCoursesFilters"
}

const reducer = (
  state = initialState,
  action: { type: actionTypes; payload?: any }
) => {
  switch (action.type) {
    case actionTypes.SET_AVAILABLE_COURSES_FILTERS: {
      return {
        ...state,
        availableCoursesFilters: action.payload
      };
    }
    case actionTypes.RESET_AVAILABLE_COURSES_FILTERS: {
      return {
        ...state,
        availableCoursesFilters: initialState.availableCoursesFilters
      };
    }
    default:
      return state;
  }
};

export const useModuleState = (): [
  State,
  Dispatch<{ type: actionTypes; payload?: any }>
] => {
  const [state, dispatch] = useContext(StateContext);
  return [state.availableCourses, dispatch];
};

export default reducer;
